export type Zone = 1 | 2 | 4;

export const ALL_ZONES: readonly Zone[] = [1, 2, 4] as const;

export type ZoneState = Readonly<Record<Zone, readonly string[]>>;
